@use "../../design-tokens/typography/typography" as *;

@layer design-system {
  .entityDetailsRoot {
    margin: 16px;
  }

  .titleContainer {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    @include typography-v2-title-lg;
    padding-right: 20px;

    &.condensed {
      @include typography-v2-body-sm;
      padding-right: 0;
    }
  }

  .titleRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .tagWrapper {
    @include typography-v2-body-sm;
    color: var(--text-soft);
    align-items: center;
    display: flex;
    gap: 4px;
  }

  .ticker {
    display: flex;
    flex-direction: row;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .contentWrapper {
    display: grid;
    grid-template:
      "ticker watchlist" auto
      "price empty" auto / auto auto;
    align-items: center;

    &.condensed {
      grid-template-columns: 10% auto 10%;
      grid-template-areas:
        "ticker price watchlist"
        "empty empty empty";
      animation: fadeIn 0.2s ease-out;
    }
  }

  .tickerWrapper {
    grid-area: ticker;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .watchlistWrapper {
    grid-area: watchlist;
    justify-self: end;
  }

  .priceWrapper {
    grid-area: price;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
  }

  .leftImageContainer {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }
}
